export function updateUrl(params) {
    let currState = Object.fromEntries(new URLSearchParams(window.location.search));
    let newStat = {...currState, ...params};
    newStat = Object.fromEntries(Object.entries(newStat).filter(([_, v]) => v != null));
    let query = new URLSearchParams(newStat);
    history.pushState(
        {},
        null,
        window.location.pathname + '?' + query.toString()
    )
    return query;
}

export function modifyCompetences(competences) {
    return competences
        .filter(el => el !== null)
        .map(el => {
            return {
                competence: el.id,
                skills: [...new Set(el.skills.filter(el => el !== null).map(el => el.id))],
            };
        });
}
